import { render, staticRenderFns } from "./funcoes.vue?vue&type=template&id=668de928&scoped=true&"
import script from "./funcoes.vue?vue&type=script&lang=js&"
export * from "./funcoes.vue?vue&type=script&lang=js&"
import style0 from "./funcoes.vue?vue&type=style&index=0&id=668de928&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668de928",
  null
  
)

export default component.exports